import Vue from 'vue'
import Vuex from 'vuex'
import cookie from 'js-cookie'
import { fetchUserInfo } from '@/api'

Vue.use(Vuex)

const USER_INFO_KEY = 'user_info'

export default new Vuex.Store({
  state: {
    user: JSON.parse(localStorage.getItem(USER_INFO_KEY)) || ''
  },
  mutations: {
    SET_USER_INFO(state, payload) {
      state.user = payload

      // 把用户信息保存到本地缓存
      localStorage.setItem(USER_INFO_KEY, JSON.stringify(payload))
    },
    LOG_OUT(state) {
      state.user = ''
      localStorage.removeItem(USER_INFO_KEY)
      cookie.remove('web-token')
    }
  },
  actions: {
    // 设置用户信息
    setUserInfo({ commit }, info) {
      return new Promise((resolve, reject) => {
        commit('SET_USER_INFO', info)

        resolve()
      })
    },

    // 更新用户信息
    uploadUserInfo({ commit }) {
      return new Promise((resolve, reject) => {
        fetchUserInfo()
          .then(res => {
            commit('SET_USER_INFO', res.data)

            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    // 登出
    logout({ commit }) {
      return new Promise((resolve, reject) => {
        commit('LOG_OUT')

        resolve()
      })
      // location.reload();
    }
  }
})
